import {useState, useEffect, useCallback} from 'react'
import useDebounce from '../../context/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner, Form, Row, Col} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import '../../appstyles/ClientsCSS/ClientsList.css';
import ExcelQuoteRequest from '../../components/ExcelQuoteRequest';
import PermissionWrapper from '../../context/PermissionWrapper';

function TrackingOrderList() {
  const axiosInstance = useAxiosPrivate();
  const [orders, setOrders] = useState({ data: [] });
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchOrders = useCallback((page, searchQuery, pageSize) => {
    setLoading(true);
    const url = searchQuery
      ? `api/quote/?page=${page}&size=${pageSize}&status=Aprobado&search=${searchQuery}`
      : `api/quote/?page=${page}&size=${pageSize}&status=Aprobado`;

    axiosInstance.get(url)
      .then(response => {
        setOrders(response.data);
        setTotalPages(response.data.totalPages);
      })
      .catch(error => {
        console.log('Failed to fetch requests', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance]);

  useEffect(() => {
      fetchOrders(currentPage, debouncedSearch, rowsPerPage);
    }, [currentPage, debouncedSearch, rowsPerPage, fetchOrders]);

  const handleRowClick = (orderId) => {
  navigate(`/order/details/${orderId}`);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
    <h2>Ordenes de Compra</h2>
    <hr />
    <Form.Control
      style={{ width: '50%' }}
      type="search"
      placeholder="Buscar por cliente, proveedor, ID o consecutivo cliente"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

    {loading ? ( 
        <div className='loading-container'>
        <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
        <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
        </div>
    ) : (  
    <Table striped bordered hover responsive
      style={{overflowY: 'auto'}}
    >
        <thead>
            <tr>
                <th>ID</th>
                <th>Cliente</th>
                <th>Proveedor</th>
                <th style={{ minWidth: '150px' }}>Producto</th>
                <th>Fabricante</th>
                <th>Incoterm</th>
                <th style={{ minWidth: '150px' }}>Consecutivo Cliente</th>
                <th>Pedido</th>
                <th style={{ minWidth: '150px' }}>Fecha Solicitada</th>
                <th style={{ minWidth: '150px' }}>Fecha de Creación</th>
                <th>Creado por</th>
            </tr>
        </thead>
        <tbody>
          {orders.data && orders.data.map(order => (
            <tr key={order.quote_id} onClick={() => handleRowClick(order.quote_id)} style={{ cursor: 'pointer' }}>
              <td>{order.quote_id}</td>
              <td>{order.client_name}</td>
              <td>{order.supplier_name}</td>
              <td style={{ minWidth: '150px' }}>
                {order.products.length > 0 ? order.products[0].product_name : ''}
                {order.products.length > 1 ? ', ...' : ''}
              </td>
              <td>
                {order.products.length > 0 ? order.products[0].product_manufacturer : ''}
                {order.products.length > 1 ? ', ...' : ''}
              </td>
              <td>{order.incoterm}</td>
              <td style={{ minWidth: '150px' }}>{order.client_consecutive ? order.client_consecutive : 'N/A'}</td>
              <td>{order.products.length > 1 ? 'Combinado' : 'Individual'}</td>
              <td style={{ minWidth: '150px' }}>{order.requested_delivery_date}</td>
              <td style={{ minWidth: '150px' }}>{order.requested_date}</td>
              <td>{order.created_by ? order.created_by : 'N/A' }</td>
            </tr>
            ))}
        </tbody>
    </Table>
    )}
    <Row style={{ alignItems: 'center', marginTop: '1.5rem' }}>
      <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
        <PermissionWrapper feature="trazabilidad" action="excel">
          <ExcelQuoteRequest status="Aprobado" label="Exportar Excel" />
        </PermissionWrapper>
      </Col>
      <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row>
    </div>
  )
}

export default TrackingOrderList